module.exports = __webpack_public_path__ + "9fbfeb7e17a900a3e1817c03cc8ec0fa.pdf";